/**
 * Implements showing and hiding tooltips for dictionary entries.
 */
H_Tools.dictionary.enableDictionaryEntries(document);
